export type MentalHealthResourceCardProps = {
  title: string;
  description: string;
  resourceLinkLabel: string;
  resourceLinkText: string;
  type: 'phone' | 'url' | 'decorative';
};

export enum PatientAssessmentCardCta {
  start = 0,
  view = 1,
}

export type PatientAssessmentCardProps = {
  id: number;
  appliedWhenID: number;
  title: string;
  type: string;
  typeID: number;
  careID: number;
  patientID: number;
  assessmentNumber: number;
  cta: PatientAssessmentCardCta;
  lastCompleted?: string;
  isTodo?: boolean;
};

export type ProviderAssessmentCardProps = {
  id: number;
  title: string;
  appliedWhen: string;
  appliedWhenID: number;
  instrumentTypeID: number;
  instrumentType: string;
  assessmentNumber: string;
  careID: number;
  patientID: number;
  ctas: string[];
  sequenceNumber: number;
  assessmentLinkSentDate?: string | null;
  assessmentLinkEmail?: string | null;
  availableForPatient?: number;
  completed?: string;
  dateAdmitted?: string;
  dateDischarged?: string;
  isCoreMeasures?: boolean;
  loadAnswersFlag?: boolean;
  assessmentStatus?: string;
  dischargeDisp?: number | null;
  submissionFrozen?: number | null;
  allowSelection?: boolean;
  onSelected?: React.ChangeEventHandler<HTMLInputElement>;
  isSelected?: boolean;
  awidEditable?: boolean | 0 | null | undefined;
  showEdit: boolean;
  onEditAppliedWhen?: React.MouseEventHandler<HTMLDivElement>;
  documentID: number;
  showDelete: boolean;
  showSelectAssessmentsWindow?: (isTabletMode: boolean) => void;
  isSupplemental?: boolean;
};

export type PatientInfoCardProps = {
  patientID: string;
  patientFirstName: string;
  patientLastName: string;
  patientDOB: string;
  patientAccountNumber: string;
  patientMedicalRecordNumber: string;
  patientProgram: string;
  patientAdmissionDate: string;
  patientDischargeDate?: string;
  patientRegistrationPIN: string;
  patientCareID?: number;
  showRegisterButton?: boolean;
  disableRegisterButton?: boolean;
};

export type AssessmentCardSectionContainer = {
  title: string;
  entries: ProviderAssessmentCardProps[];
};

export type ReportCardProps = {
  title: string;
  reportIDHash: string;
  reportDesc: string;
  isCoreMeasures: boolean;
  programFilter: string | null;
  programFilterID: number | null;
};
